'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  padding: 0.6em 0.8em;\n  border-radius: 50%;\n  right: ', ';\n  left: ', ';\n  top: ', ';\n  bottom: ', ';\n  background: ', ';\n  color:  ', ';\n  cursor: pointer;\n  z-index: 99999;\n  border: 1px ', ' solid;\n\n  &:hover {\n    background: ', ';\n    border: 1px ', ' solid;\n    color:  ', ';\n  }\n'], ['\n  position: absolute;\n  padding: 0.6em 0.8em;\n  border-radius: 50%;\n  right: ', ';\n  left: ', ';\n  top: ', ';\n  bottom: ', ';\n  background: ', ';\n  color:  ', ';\n  cursor: pointer;\n  z-index: 99999;\n  border: 1px ', ' solid;\n\n  &:hover {\n    background: ', ';\n    border: 1px ', ' solid;\n    color:  ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, function (props) {
  return props.horizontal === 'right' ? '-1em' : '';
}, function (props) {
  return props.horizontal === 'left' ? '-1em' : '';
}, function (props) {
  return props.vertical === 'top' ? '-1em' : '';
}, function (props) {
  return props.vertical === 'bottom' ? '-1em' : '';
}, _color2.default.white, _color2.default.blue_accent, _color2.default.blue_accent, _color2.default.blue_accent, _color2.default.white, _color2.default.white);

var MozartCloseButton = function MozartCloseButton(props) {
  var style = props.style,
      vertical = props.vertical,
      horizontal = props.horizontal,
      onClick = props.onClick,
      testId = props.testId,
      themeId = props.themeId;

  return _react2.default.createElement(
    Container,
    { 'data-qa': testId, vertical: vertical, horizontal: horizontal, style: style, onClick: onClick, 'data-theme': themeId },
    _react2.default.createElement('span', { className: 'icon-Close' })
  );
};

MozartCloseButton.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** horizontal position: right, left */
  horizontal: _propTypes2.default.string,
  /** vertical position: top, bottom */
  vertical: _propTypes2.default.string,
  /** onClick callback */
  onClick: _propTypes2.default.func
};

MozartCloseButton.defaultProps = {
  horizontal: 'right',
  vertical: 'top',
  testId: 'MozartCloseButton',
  themeId: 'MozartCloseButton'
};

exports.default = MozartCloseButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartButton/MozartCloseButton/MozartCloseButton.js
// module id = 714
// module chunks = 1